import React, { useState } from 'react';
import { TableContent } from 'entities/table/ui/TableContent';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetBrandsQuery } from 'features/useBrands';
import { BrandFormWidget } from 'widgets/content/ui/BrandFormWidget';
import { BrandType } from 'widgets/content/types';

const fields = [
  { field: 'id', title: 'ID', width: '5%' },
  { field: 'title', title: 'Заголовок', width: '25%' },
  { field: 'image', title: 'Медиа', width: '20%' },
  { field: 'priority', title: 'Приоритет', width: '20%' },
];

const BrandImage = ({ src }: { src: string }) => (
  <Box
    component="img"
    sx={{ height: '50px', width: '50px', objectFit: 'cover' }}
    alt="Alt text"
    src={src}
  />
);

export const BrandListWidget = () => {
  const { app_type } = useParams();
  const navigate = useNavigate();
  const [pagination, setPagination] = useState<{ page: number; count: number }>({ page: 0, count: 10 });

  const brands = useGetBrandsQuery({
    app_type,
    page: pagination.page + 1,
    size: pagination.count,
  });

  const listTable = () => {
    if (brands.data) {
      return brands.data.items.map((item: BrandType) => ({
        id: item.id,
        title: item.title,
        priority: item.priority || '---',
        image: <BrandImage src={item.image} />,
      }));
    }
    return [];
  };

  const handleDetail = (id: number) => {
    navigate(`/content/brands/${app_type}/${id}`);
  };

  if (brands.isFetching) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (brands.isError) {
    return <Stack alignItems="center">ERROR</Stack>;
  }

  return brands.isSuccess ? (
    <>
      {brands.data.total > 0 ? (
        <TableContent
          title={`Список брендов ${app_type?.toUpperCase()}`}
          fields={fields}
          list={{ list: listTable() }}
          count={brands.data.total}
          page={pagination.page}
          perPage={pagination.count}
          onPageChange={(_, page) => {
            setPagination((prev) => ({ ...prev, page }));
          }}
          onRowsPerPageChange={(e) => {
            setPagination(() => ({
              page: 0,
              count: e.target.value as any,
            }));
          }}
          onRowClick={handleDetail}
        />
      ) : (
        <Typography align="center">В данный момент, отсутствуют данные по этой таблице</Typography>
      )}

      <BrandFormWidget refetch={brands.refetch} />
    </>
  ) : null;
};
